<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <cruises-breadcrumbs :search-request="searchRequest" :product="product" />
        </template>
        <template v-slot:sidebar>
            <cruises-search-summary search-disabled :search-request="searchRequest" :dates="dates" />
            <cruise-order-summary
                :product="product"
                :offer="offer"
                :search-request="searchRequest"
                :info="basketItem.info"
                :selected-add-ons="selectedAddOns"
                :extra-services="extraServices"
                :additional-options="bookingAdditionalOptions"
                :prepare-book-response="prepareBookResponse"
            />
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import ConfirmationStatus from '@/components/booking/ConfirmationStatus.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import CruisesBreadcrumbs from '@/components/cruises/CruisesBreadcrumbs.vue'
    import CruisesSearchSummary from '@/components/cruises/search/CruisesSearchSummary.vue'
    import CruiseOrderSummary from '@/components/cruises/booking/CruiseOrderSummary.vue'
    import {CruisesPageMixin} from '~src/components/cruises/mixins/CruisesPageMixin.vue'
    import {CruisesStoreMixin} from '@/mixins/CruisesStoreMixin.vue'

    @Component({
        components: {
            CruiseOrderSummary,
            CruisesSearchSummary,
            CruisesBreadcrumbs,
            ConfirmationPageLayout,
            ConfirmationStatus,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class CruiseConfirmationPage extends mixins(CruisesPageMixin, CruisesStoreMixin, ConfirmationPageMixin) {
        formattedDate(date) {
            return date ? this.$filters.dateFormat(this.$dateFns.parseISO(date)) : ''
        }

        get dates() {
            return `${this.formattedDate(this.searchRequest.startDate)} - ${this.formattedDate(
                this.searchRequest.endDate
            )}`
        }

        get basketItem() {
            return this.productStore.basketItem(this.productStore.prepareBookRequest.offerKey)
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get product() {
            return this.basketItem.product
        }

        get offer() {
            return this.product.offers.find(offer => offer.offerKey === this.basketItem.offerKey)
        }
    }

    export default CruiseConfirmationPage
</script>
